export const encodeBase64 = data => btoa(JSON.stringify(data));
export const decodeBase64 = string => JSON.parse(atob(string));
